import { Theme } from '@mui/material';
import { hexToRGB } from 'src/utils';
import { customShadows } from 'src/theme';

const notificationShared = {
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'row',
  position: 'absolute',
  maxWidth: 500,
  backgroundColor: 'grey.800',
  marginLeft: '16px',
  padding: 0.5,
  borderRadius: 1,
  boxShadow: customShadows.dark.z8 as string,
  zIndex: 1,
};

export const sxNotification = {
  ...notificationShared,
  right: 16,
  top: 16,
  marginLeft: '16px',
};

export const mdNotification = {
  ...notificationShared,
  right: 24,
  top: 24,
  marginLeft: '24px',
};

export const sxNotificationText = {
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  minWidth: 140,
};

export const sxNotificationAction = {
  display: 'flex',
  alignItems: 'center',
  ml: 1.5,
};

export const sxIcon = (color: 'warning' | 'success') => (theme: Theme) => ({
  borderRadius: 1,
  mr: 1,
  width: '48px',
  height: '48px',
  backgroundColor: hexToRGB(theme.palette[color].main, '0.16'),
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});
